import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import api from "../../api/axiosInstance";

const UploadCsv = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();
  const navigate = useNavigate();

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");

  const uploadMethod = watch("upload_method", "manual");

  const onSubmit = async (formData) => {
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("upload_method", formData.upload_method);
      data.append("delimiter", formData.delimiter);
      data.append("update_interval", formData.update_interval);

      if (formData.upload_method === "manual" && formData.file[0]) {
        data.append("file", formData.file[0]);
      } else if (formData.upload_method === "url") {
        data.append("file_url", formData.file_url);
      }

      const response = await api.post("/api/csv", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setMessage("CSV uploaded successfully!");
        setMessageType("success");
        reset();
        setTimeout(() => navigate("/csv"), 2000);
      } else {
        const { message } = response.data;
        setMessage(message || "Failed to upload CSV.");
        setMessageType("danger");
      }
    } catch (error) {
      setMessage("Error submitting the form. Please try again later.");
      setMessageType("danger");
    }
  };

  return (
    <div className="row">
      <div className="col-md-4">
        <h2>Upload CSV</h2>
        <hr />
        {message && (
          <div className={`alert alert-${messageType}`} role="alert">
            {message}
          </div>
        )}
        <form className="form-group" onSubmit={handleSubmit(onSubmit)}>
          {/* CSV Name */}
          <div>
            <label>CSV Name:</label>
            <input
              className="form-control"
              type="text"
              {...register("name", { required: "CSV Name is required" })}
            />
            {errors.name && (
              <p className="text-danger">{errors.name.message}</p>
            )}
          </div>
          <hr />

          {/* Upload Method */}
          <div>
            <label>Upload Method:</label>
            <select
              className="form-control"
              {...register("upload_method", {
                required: "Upload Method is required",
              })}
            >
              <option value="manual">Upload Manually</option>
              <option value="url">From URL</option>
            </select>
            {errors.upload_method && (
              <p className="text-danger">{errors.upload_method.message}</p>
            )}
          </div>
          <hr />

          {/* File Upload or URL Input */}
          {uploadMethod === "manual" ? (
            <div>
              <label>Upload File:</label>
              <input
                className="form-control"
                type="file"
                {...register("file", {
                  required: "File is required for manual upload",
                })}
              />
              {errors.file && (
                <p className="text-danger">{errors.file.message}</p>
              )}
            </div>
          ) : (
            <div>
              <label>File URL:</label>
              <input
                className="form-control"
                type="text"
                {...register("file_url", {
                  required: "File URL is required for URL upload",
                })}
              />
              {errors.file_url && (
                <p className="text-danger">{errors.file_url.message}</p>
              )}
            </div>
          )}
          <hr />

          {/* Delimiter */}
          <div>
            <label>Delimiter:</label>
            <input
              className="form-control"
              type="text"
              {...register("delimiter", { required: "Delimiter is required" })}
            />
            {errors.delimiter && (
              <p className="text-danger">{errors.delimiter.message}</p>
            )}
          </div>
          <hr />

          {/* Update Interval */}
          <div>
            <label>Update Interval (minutes):</label>
            <input
              className="form-control"
              type="number"
              {...register("update_interval")}
            />
          </div>
          <hr />

          {/* Submit Button */}
          <div>
            <button type="submit" className="btn btn-primary">
              Upload CSV
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UploadCsv;